import { InjectionToken } from "@angular/core";
import { AddressDto } from "projects/shared/lib/services/INTEGRA_Shop_Client";

export abstract class IAddressListDialogService
{

  abstract addressListDialogShow(
    modalTitle: string,
    addressList: AddressDto[],
    callbackSubmit: () => void,
    callbackCancel: () => void,
    submitButtonLabel?: string,
  ): unknown;

}
/** Injection token which makes it possible to provide and inject the interface. */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const IAddressListDialogServiceToken = new InjectionToken<IAddressListDialogService>('IAddressListDialogServiceToken');

